/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1TutoraiDashboardReportQueryResponse,
  GetApiV1TutoraiDashboardReportQueryParams,
  GetApiV1TutoraiDashboardReport400,
  GetApiV1TutoraiDashboardReport401,
  GetApiV1TutoraiDashboardReport500,
} from "../../types/tutorAIDashboardController/GetApiV1TutoraiDashboardReport.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1TutoraiDashboardReport } from "../../clients/tutorAIDashboardController/getApiV1TutoraiDashboardReport.ts";

export const getApiV1TutoraiDashboardReportQueryKey = (
  params?: GetApiV1TutoraiDashboardReportQueryParams,
) =>
  [
    { url: "/api/v1/tutorai/dashboard/report" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1TutoraiDashboardReportQueryKey = ReturnType<
  typeof getApiV1TutoraiDashboardReportQueryKey
>;

export function getApiV1TutoraiDashboardReportQueryOptions(
  params?: GetApiV1TutoraiDashboardReportQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1TutoraiDashboardReportQueryKey(params);
  return queryOptions<
    GetApiV1TutoraiDashboardReportQueryResponse,
    ResponseErrorConfig<
      | GetApiV1TutoraiDashboardReport400
      | GetApiV1TutoraiDashboardReport401
      | GetApiV1TutoraiDashboardReport500
    >,
    GetApiV1TutoraiDashboardReportQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1TutoraiDashboardReport(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Consolida métricas de custo e engajamento do TutorAI para um período obrigatório.
 * Filtros opcionais: `classStudentId` (turma) e `courseId` (curso).
 * `start` não pode ser posterior a `end`; `end` não pode ser uma data futura. **(Requer Authorization para autenticação)**
 * @summary Relatório administrativo de uso do chat (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/dashboard/report}
 */
export function useGetApiV1TutoraiDashboardReport<
  TData = GetApiV1TutoraiDashboardReportQueryResponse,
  TQueryData = GetApiV1TutoraiDashboardReportQueryResponse,
  TQueryKey extends QueryKey = GetApiV1TutoraiDashboardReportQueryKey,
>(
  params?: GetApiV1TutoraiDashboardReportQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1TutoraiDashboardReportQueryResponse,
        ResponseErrorConfig<
          | GetApiV1TutoraiDashboardReport400
          | GetApiV1TutoraiDashboardReport401
          | GetApiV1TutoraiDashboardReport500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1TutoraiDashboardReportQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1TutoraiDashboardReportQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1TutoraiDashboardReport400
      | GetApiV1TutoraiDashboardReport401
      | GetApiV1TutoraiDashboardReport500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
